import React, { forwardRef } from 'react';

type Props = React.SVGProps<SVGCircleElement>;

const Circle = forwardRef<SVGCircleElement, Props>((props, ref) => {
  return <circle ref={ref} {...props} />;
});

export default Circle;
